/* eslint-disable import/no-extraneous-dependencies */

import React, { Fragment } from 'react';

const Wrapper = ({ children }) => <Fragment>{children}</Fragment>;

export default Wrapper;
